<template>
  <a-locale-provider :locale="locale">
    <div id="app"><router-view /></div>
  </a-locale-provider>
</template>

<script>
import { mapGetters } from 'vuex'
import zh_CN from 'ant-design-vue/lib/locale-provider/zh_CN'
import moment from 'moment'
import 'moment/locale/zh-cn'

export default {
  data() {
    return {
      locale: zh_CN
    }
  },

  computed: {
    ...mapGetters(['localeLanguage'])
  },

  watch: {
    // 语言变动
    localeLanguage(val) {
      // 本地持久化
      localStorage.setItem('locale', val)
      this.$i18n.locale = val
      switch (val) {
        case 'zh_CN':
          moment.locale('zh-cn')
          this.locale = zh_CN
          break

        case 'en':
          moment.locale('en')
          this.locale = null
          break

        default:
          moment.locale('en')
          this.locale = null
          break
      }
    }
  },

  created() {
    // 从本地读取语言
    if (!localStorage.getItem('locale')) {
      localStorage.setItem('locale', this.$i18n.locale)
    }
    this.$store.commit('SET_LOCALELANGUAGE', localStorage.getItem('locale'))
  }
}
</script>

<style lang="less" scoped>
@import './style/mixin.less';

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  .box-hidden();
  min-width: 1000px;
  /deep/ .ant-table-tbody {
    .border {
      position: relative;
      top: -0.06em;
      display: inline-block;
      width: 1px;
      height: 0.9em;
      margin: 0 8px;
      vertical-align: middle;
      background-color: #e8e8e8;
    }
  }
}
</style>
